import Layout from '@/layout';
var commissionerRouter = {
  path: '/commissioner',
  component: Layout,
  redirect: '/commissioner/list',
  name: 'commissioner',
  meta: {
    title: '专员',
    icon: 'user'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/commissioner/index');
    },
    name: 'commissionerList',
    meta: {
      title: '专员备案',
      icon: 'user'
    }
  }]
};
export default commissionerRouter;